import 'slick-carousel/slick/slick';
import 'bootstrap/dist/js/bootstrap.bundle';
import './navigation';
import { Fancybox } from "@fancyapps/ui";

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

// init Swiper:
const swiper = new Swiper('.swiper-container', {
	// configure Swiper to use modules
	modules: [Navigation, Pagination],
	// Optional parameters
	slidesPerView: 1,
	spaceBetween: 30,
	centeredSlides: true,

	// Navigation arrows
	navigation: {
		nextEl: '.swiper-custom-button-next',
		prevEl: '.swiper-custom-button-prev',
	}
});

Fancybox.bind("[data-fancybox]", {
	// Your custom options
});

$('.image-slider').slick({
	rows: 0,
	prevArrow: '<div class="image-slider__prev"></div>',
	nextArrow: '<div class="image-slider__next"></div>',
});

swiper.on('slideChange', function () {
	$('.current-slide').html(swiper.activeIndex + 1);
});

// Comic Slider — Swiper instance per block
document.querySelectorAll('.comic-slider .comic-swiper').forEach(function (el) {
	const $slider = $(el).closest('.comic-slider');
	new Swiper(el, {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		spaceBetween: 24,
		grabCursor: true,
		keyboard: { enabled: true },
		navigation: {
			nextEl: $slider.find('.comic-nav--next')[0],
			prevEl: $slider.find('.comic-nav--prev')[0],
		},
		pagination: {
			el: $slider.find('.comic-pagination')[0],
			clickable: true,
		},
	});
});

// Testimonial Slider — Swiper instance per block, auto-height cards
document.querySelectorAll('.testimonial-slider .testimonial-swiper').forEach(function (el) {
	const $slider = $(el).closest('.testimonial-slider');
	new Swiper(el, {
		modules: [Navigation],
		slidesPerView: 1,
		spaceBetween: 24,
		grabCursor: true,
		keyboard: { enabled: true },
		breakpoints: {
			576: { slidesPerView: 1.4, spaceBetween: 24 },
			768: { slidesPerView: 2,   spaceBetween: 28 },
			992: { slidesPerView: 3,   spaceBetween: 32 },
		},
		navigation: {
			nextEl: $slider.find('.testimonial-slider__nav--next')[0],
			prevEl: $slider.find('.testimonial-slider__nav--prev')[0],
		},
	});
});

// ---------------------------------------------------------------------------
// Store Locator — Vor-Ort-Läden
// Leaflet is enqueued conditionally (only on pages with the block), so we
// bail early when window.L is missing so this file stays inert elsewhere.
// ---------------------------------------------------------------------------
function initStoreLocator(root) {
	if (typeof window.L === 'undefined') return;
	const dataEl = root.querySelector('.store-locator__data');
	const listEl = root.querySelector('[data-locator-list]');
	const mapEl  = root.querySelector('[data-locator-map]');
	const formEl = root.querySelector('[data-locator-search]');
	const input  = root.querySelector('[data-locator-input]');
	const radius = root.querySelector('[data-locator-radius]');
	const reset  = root.querySelector('[data-locator-reset]');
	const status = root.querySelector('[data-locator-status]');
	if (!dataEl || !mapEl || !listEl) return;

	let stores;
	try { stores = JSON.parse(dataEl.textContent); } catch (e) { return; }
	if (!Array.isArray(stores) || stores.length === 0) return;

	const map = window.L.map(mapEl, { scrollWheelZoom: false }).setView([46.8, 8.2], 8);
	window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		maxZoom: 19,
		attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	}).addTo(map);

	const markers = {};
	const bounds  = window.L.latLngBounds([]);
	stores.forEach(function (store) {
		const marker = window.L.marker([store.lat, store.lng]).addTo(map);
		const safeName = String(store.name || '').replace(/[<>"]/g, '');
		marker.bindPopup(
			'<strong>' + safeName + '</strong><br>' +
			(store.street || '') + '<br>' +
			(store.zip || '') + ' ' + (store.city || '')
		);
		marker.on('click', function () {
			const card = listEl.querySelector('[data-store-id="' + store.id + '"]');
			if (card) {
				listEl.querySelectorAll('.store-card.is-active').forEach(function (c) { c.classList.remove('is-active'); });
				card.classList.add('is-active');
				card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			}
		});
		markers[store.id] = marker;
		bounds.extend([store.lat, store.lng]);
	});
	if (bounds.isValid()) map.fitBounds(bounds, { padding: [30, 30] });

	// Card-click → open marker popup
	listEl.addEventListener('click', function (e) {
		const card = e.target.closest('.store-card');
		if (!card) return;
		if (e.target.closest('a')) return;
		const m = markers[card.dataset.storeId];
		if (m) {
			map.flyTo(m.getLatLng(), Math.max(map.getZoom(), 13), { duration: 0.5 });
			m.openPopup();
		}
	});

	let searchMarker = null;
	function clearSearchMarker() {
		if (searchMarker) {
			map.removeLayer(searchMarker);
			searchMarker = null;
		}
	}

	function haversineKm(lat1, lng1, lat2, lng2) {
		const R = 6371;
		const dLat = (lat2 - lat1) * Math.PI / 180;
		const dLng = (lng2 - lng1) * Math.PI / 180;
		const a = Math.sin(dLat / 2) ** 2
			+ Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
		return 2 * R * Math.asin(Math.sqrt(a));
	}

	function resetView() {
		clearSearchMarker();
		listEl.querySelectorAll('.store-card').forEach(function (card) {
			card.hidden = false;
			card.classList.remove('is-active');
			const d = card.querySelector('[data-store-distance]');
			if (d) d.textContent = '';
		});
		// Restore natural alphabetical order (already in DOM order from PHP)
		Array.from(listEl.querySelectorAll('.store-card'))
			.sort(function (a, b) { return Number(a.dataset.storeId) - Number(b.dataset.storeId); })
			.forEach(function (c) { listEl.appendChild(c); });
		Object.values(markers).forEach(function (m) { map.addLayer(m); });
		if (bounds.isValid()) map.fitBounds(bounds, { padding: [30, 30] });
		status.textContent = '';
		reset.hidden = true;
	}

	reset.addEventListener('click', function () {
		input.value = '';
		resetView();
	});

	formEl.addEventListener('submit', async function (e) {
		e.preventDefault();
		const q = input.value.trim();
		if (!q) return;
		const radiusKm = Number(radius.value);

		status.textContent = 'Suche „' + q + '" …';

		try {
			const url = 'https://nominatim.openstreetmap.org/search?'
				+ 'q=' + encodeURIComponent(q)
				+ '&format=json&limit=1&countrycodes=ch,de,at,li';
			const res = await fetch(url, { headers: { 'Accept-Language': 'de' } });
			const data = await res.json();
			if (!Array.isArray(data) || data.length === 0) {
				status.textContent = 'Ort nicht gefunden. Versuche eine andere Schreibweise.';
				return;
			}
			const lat = parseFloat(data[0].lat);
			const lng = parseFloat(data[0].lon);

			clearSearchMarker();
			searchMarker = window.L.circleMarker([lat, lng], {
				radius: 8,
				color: '#000',
				weight: 2,
				fillColor: '#1abc9c',
				fillOpacity: 1,
			}).addTo(map).bindPopup('<strong>' + q + '</strong>');

			let visibleCount = 0;
			const sorted = stores.map(function (s) {
				return Object.assign({}, s, { distance: haversineKm(lat, lng, s.lat, s.lng) });
			}).sort(function (a, b) { return a.distance - b.distance; });

			sorted.forEach(function (store) {
				const card = listEl.querySelector('[data-store-id="' + store.id + '"]');
				if (!card) return;
				const inRange = radiusKm === 0 || store.distance <= radiusKm;
				card.hidden = !inRange;
				const distEl = card.querySelector('[data-store-distance]');
				if (distEl) distEl.textContent = store.distance.toFixed(1).replace('.', ',') + ' km';
				if (inRange) {
					visibleCount++;
					map.addLayer(markers[store.id]);
					listEl.appendChild(card);
				} else {
					map.removeLayer(markers[store.id]);
				}
			});

			const visibleBounds = window.L.latLngBounds([[lat, lng]]);
			sorted.filter(function (s) { return radiusKm === 0 || s.distance <= radiusKm; })
				.forEach(function (s) { visibleBounds.extend([s.lat, s.lng]); });
			if (visibleBounds.isValid()) map.fitBounds(visibleBounds, { padding: [40, 40] });

			status.textContent = visibleCount > 0
				? visibleCount + ' Laden' + (visibleCount === 1 ? '' : ' / Läden') + ' im Umkreis gefunden.'
				: 'Keine Läden im gewählten Umkreis. Erweitere den Radius oder wähle „Alle anzeigen".';
			reset.hidden = false;
		} catch (err) {
			status.textContent = 'Suche fehlgeschlagen. Bitte später erneut versuchen.';
		}
	});
}

document.querySelectorAll('.store-locator').forEach(initStoreLocator);

// ---------------------------------------------------------------------------
// Cookie notice — Swiss law (revDSG) requires transparency, not consent,
// so the banner just informs and is dismissed for good once acknowledged.
// Persisted in localStorage so it stays gone across visits on the same
// browser. Hidden by default in markup to avoid a flash before this runs.
// ---------------------------------------------------------------------------
(function () {
	var notice = document.querySelector('[data-cookie-notice]');
	if (!notice) return;
	var KEY = 'sweetsocks_cookie_notice_dismissed';
	try {
		if (localStorage.getItem(KEY) === '1') return;
	} catch (e) { /* localStorage may be disabled — still show the notice */ }
	notice.hidden = false;
	var dismiss = notice.querySelector('[data-cookie-dismiss]');
	if (dismiss) {
		dismiss.addEventListener('click', function () {
			notice.hidden = true;
			try { localStorage.setItem(KEY, '1'); } catch (e) {}
		});
	}
})();

// ---------------------------------------------------------------------------
// Language switcher dropdown — toggle on button click, close on outside
// click or Escape. Multiple instances supported (e.g. desktop + future
// duplicates) by binding per `[data-language-switcher]` root.
// ---------------------------------------------------------------------------
document.querySelectorAll('[data-language-switcher]').forEach(function (root) {
	var toggle = root.querySelector('[data-language-toggle]');
	if (!toggle) return;
	function setOpen(open) {
		root.classList.toggle('is-open', open);
		toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
	}
	toggle.addEventListener('click', function (e) {
		e.stopPropagation();
		setOpen(!root.classList.contains('is-open'));
	});
	document.addEventListener('click', function (e) {
		if (!root.contains(e.target)) setOpen(false);
	});
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') setOpen(false);
	});
});

$(document).ready(function () {
	$('.location-filter').on('click', '.location-filter__pill', function () {
		const $pill = $(this);
		const filter = $pill.data('filter');
		$pill.siblings().removeClass('is-active');
		$pill.addClass('is-active');
		$('.archive-card').each(function () {
			const $card = $(this);
			if (filter === 'all') {
				$card.removeClass('is-hidden');
				return;
			}
			const locations = ('' + ($card.data('locations') || '')).split(/\s+/);
			$card.toggleClass('is-hidden', locations.indexOf(filter) === -1);
		});
	});
});

